import React from "react";

const STORAGE_KEY = "jabuzwane-analytics-consent";

export function getAnalyticsConsent() {
	try {
		const saved = window.localStorage.getItem(STORAGE_KEY);
		return saved === "granted" || saved === "denied" ? saved : null;
	} catch {
		return null;
	}
}

export default function AnalyticsConsent({ consent, onChoose }) {
	if (consent) return null;

	return (
		<section className="analytics-consent" role="dialog" aria-label="Analytics preferences">
			<div className="analytics-consent__copy">
				<strong>Help us improve Jabuzwane</strong>
				<p>May we use Google Analytics to understand how visitors use this website?</p>
			</div>
			<div className="analytics-consent__actions">
				<button className="analytics-consent__decline" type="button" onClick={() => onChoose("denied")}>
					No thanks
				</button>
				<button className="analytics-consent__accept" type="button" onClick={() => onChoose("granted")}>
					Accept analytics
				</button>
			</div>
		</section>
	);
}
